// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"0846dbd6","618":"1e234544"}[chunkId] + ".chunk.js";
};